module.exports = __webpack_public_path__ + "img/page_bg_dataCenter.b7573dbc.png";